
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMedia } from '@/utils/useMedia'
import 'vue3-carousel/dist/carousel.css'
import CourseModal from '../CoursesModal.vue'
import { getUser, useEvent } from '@coderhouse/common'
import { getMainJourney } from '@/api/new-suggested-courses.api'

export default defineComponent({
  components: { CourseModal },
  props: {
    homeToast: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n()
    const isDesktop = useMedia('(min-width: 1280px)')
    const isMediumDesktop = useMedia('(min-width: 768px)')
    const isMobile = useMedia('(max-width: 760px)')
    const showModal = ref<boolean>(false)
    const user = ref()
    const courseID = ref()
    const cards = ref<Element>()
    const topModal = ref()
    const homeToastObj = ref(props.homeToast)
    const isUserBr = ref<boolean>(true)
    const journeyCourses = ref()
    const singleCard = ref()
    const noCoursesToBuy = ref()
    const subtitle = ref<string>('')

    const openModal = (id: string) => {
      courseID.value = id
      showModal.value = true
      const viewportOffset = cards.value?.getBoundingClientRect()
      const top = viewportOffset?.top
      if (top) {
        topModal.value = `${window.innerHeight - top}px`
      }
      useEvent('trackEvent', 'cta', 'suggested-course', 'open_suggestedCourse_modal')
    }

    const closeModal = () => {
      courseID.value = ''
      showModal.value = false
    }

    const sizeCards = () => {
      if (journeyCourses.value.length == 3) {
        return 'w-[23rem]'
      } else if (journeyCourses.value.length == 2) {
        return 'w-[35rem]'
      } else if (journeyCourses.value.length == 1) {
        singleCard.value = true
      } else {
        singleCard.value = true
        noCoursesToBuy.value = true
      }
    }

    onMounted(async () => {
      journeyCourses.value = await getMainJourney()
      user.value = await getUser()
      isUserBr.value = user.value.country === 'br'
      subtitle.value = t('home-suggested-courses-subtitle-new')
    })

    const tagColors = (tag: string) => {
      switch (tag) {
        case 'design':
          return 'designTag'
        case 'marketing':
          return 'marketingTag'
        case 'development':
          return 'devTag'
        case 'product':
          return 'productTag'
        case 'data':
          return 'dataTag'
        case 'digital-arts':
          return 'artTag'
        case 'finance':
          return 'financeTag'
        case 'business':
          return 'businessTag'
        case 'cybersecurity':
          return 'ciberseguridadTag'
        case 'tool':
          return 'toolsTag'
        case 'no-code':
          return 'noCodeTag'
        default:
          return 'otherTag'
      }
    }

    const upperFirstLetter = (tag: string) => {
      let words = tag.split('-')
      let wordsUpperLetter = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      return wordsUpperLetter.join('-')
    }

    const translateTag = (tag: string) => {
      switch (tag) {
        case 'design':
          return 'core.constants.categories.design'
        case 'marketing':
          return 'core.constants.categories.marketing'
        case 'development':
          return 'core.constants.categories.development'
        case 'product':
          return 'core.constants.categories.product'
        case 'data':
          return 'core.constants.categories.data'
        case 'digital-arts':
          return 'core.constants.categories.digital-arts'
        case 'finance':
          return 'core.constants.categories.finance'
        case 'business':
          return 'core.constants.categories.business'
        case 'cybersecurity':
          return 'core.constants.categories.cybersecurity'
        case 'tool':
          return 'core.constants.categories.tool'
        case 'no-code':
          return 'core.constants.categories.no-code'
        default:
          return upperFirstLetter(tag)
      }
    }

    return {
      t,
      isDesktop,
      isMediumDesktop,
      showModal,
      user,
      openModal,
      closeModal,
      courseID,
      cards,
      topModal,
      isMobile,
      tagColors,
      homeToastObj,
      isUserBr,
      journeyCourses,
      sizeCards,
      translateTag,
      singleCard,
      noCoursesToBuy,
      subtitle
    }
  }
})
